import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Consent } from '@shared/interfaces';
import { DatalistsService } from '@shared/services';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { getDatalistConsents, getDatalistCountries } from '.';
import { loadCountries, addCountries, loadFailure, loadConsents, addConsents } from './datalists.actions';

@Injectable()
export class DatalistsEffects {

  addCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCountries),
      withLatestFrom(this.store.select(getDatalistCountries)),
      switchMap(([ { lang }, countries])  =>
        {
          // if (countries?.length) {
          //   return of(addCountries({ countries }));
          // }
          return this.datalists.getCountries(lang).pipe(
            map(countries => addCountries({ countries })),
            catchError(error => of(loadFailure({ error })))
          );
        }
      )
    )
  );

  addConsents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadConsents),
      withLatestFrom(this.store.select(getDatalistConsents)),
      switchMap(([{ lang }, consents])  =>
        {
          // if (consents) {
          //   return of(addConsents({ consents }));
          // }

          return this.datalists.getConsents(lang).pipe(
            map(data => addConsents({
              consents: this.convertConsentsToObject(data)
            })),
            catchError(error => of(loadFailure({ error })))
          );
        }
      )
    )
  );

  private convertConsentsToObject(data: Consent[]) {
    const consents: {[key in string]: Consent} = {};
    for (const item of data) {
      consents[item.key] = item;
    }
    return consents;
  }

  constructor(
    private actions$: Actions,
    private datalists: DatalistsService,
    private store: Store
  ) {}

}
